<template>
  <div class="textualReview">
    <div class="left">
      <div class="hender fjcsb">
        <div>
          <template v-if="yzDoctorCheckList.mvsData">
            <span class="item strong">MVS完成率（{{ yzDoctorCheckList.mvsData.employeeName }}）</span>
            <span class="item"
              >完成率：{{ yzDoctorCheckList.mvsData.completionRate }}%</span
            >
            <span class="item"
              >患者抽查数：{{ yzDoctorCheckList.mvsData.allNum }}</span
            >
            <span class="item"
              >合格数：{{ yzDoctorCheckList.mvsData.passNum }}</span
            >
          </template>
          
          <span class="item" v-if="yzDoctorCheckList.selectEmployeeInfo.length"
            >被检视人
            <Select
              v-model="employeeId"
              style="width: 120px"
              @on-change="getData"
              clearable
            >
              <Option
                v-for="item in yzDoctorCheckList.selectEmployeeInfo"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </span>

          <span class="item"
            >看诊月份
            <DatePicker
              v-model="visitDate"
              type="month"
              style="width: 120px"
              @on-change="getData"
              :options="options"
            ></DatePicker
          ></span>
          <span class="item"
            >检视月份
            <DatePicker
              v-model="checkDate"
              type="month"
              style="width: 120px"
              @on-change="getData"
              :options="options"
            ></DatePicker
          ></span>
        </div>
        <Button type="primary" @click="search">查询</Button>
      </div>
      <div class="t_body">
        <Table
          ref="currentRowTable"
          :columns="columns1"
          :data="yzDoctorCheckList.listData"
          highlight-row
          @on-row-click="rowClick"
          border
          :height="u_table_heigh"
        >
          <!-- Mvs结果（1 提醒 2 合格 3 不合格） -->
          <template slot-scope="{ row }" slot="mvsResult">
            <span v-if="row.mvsResult == 1" class="success">提醒</span>
            <span v-else-if="row.mvsResult == 2" class="text-green">合格</span>
            <span v-else-if="row.mvsResult == 3" class="text-red">不合格</span>
          </template>
          <template slot-scope="{ row }" slot="errorNum">
            {{ row.errorNum }}
            <Tag v-if="[10, 20].includes(row.doctorReplyType)" color="red"
              >待回复</Tag
            >
          </template>
        </Table>
      </div>
      <Page
        show-total
        show-sizer
        :page-size-opts="[5, 10, 20, 30, 40]"
        @on-change="pageChange"
        :total="totalCount"
        :page-size="pageSize"
        :current="pageIndex"
        @on-page-size-change="setPageSize"
      ></Page>
    </div>
    <div class="right" v-if="acitveItem">
      <detail
        :info="acitveItem"
        @change="getData"
        @close="closeDetail"
      ></detail>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import detail from "./com/detail.vue";
import request from "@/utils/request";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);
export default {
  components: {
    detail,
  },
  computed: {
    ...mapGetters(["userInfo", "hospitalList"]),
  },
  data() {
    return {
      // 表格高度
      u_table_heigh: 500,
      options: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        },
      },
      acitveItem: "",
      employeeId: "",
      yzDoctorCheckList: {
        listData: [],
        mvsData: {},
        selectEmployeeInfo: [],
      },
      visitDate: dayjs().format("YYYY-MM-DD"),
      checkDate: dayjs().format("YYYY-MM-DD"),
      pageIndex: 1,
      pageSize: 30,
      totalCount: 0,
      tableData: [],
      columns1: [
        {
          title: "医馆",
          key: "hospitalName",
          width: 180,
        },
        {
          title: "患者",
          key: "patientInfoStr",
          width: 220,
        },
        {
          title: "看诊日期",
          key: "visitDate",
          width: 120,
        },
        {
          title: "检视日期",
          key: "checkDate",
          width: 120,
        },
        {
          title: "被检视人",
          key: "employeeInfoStr",
          width: 150,
        },
        {
          title: "MVS检视结果",
          key: "mvsResult",
          slot: "mvsResult",
          width: 150,
        },
        {
          title: "被扣分项目数",
          key: "errorNum",
          slot: "errorNum",
          width: 150,
        },
        {
          title: "默认回复倒计时",
          key: "replyCloseTimeStr",
          minWidth: 160,
        },
      ],
    };
  },
  methods: {
    pageChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.getData();
    },
    setPageSize(pageSize) {
      this.pageSize = pageSize;
      this.search();
    },
    search() {
      this.acitveItem = null;
      this.pageIndex = 1;
      this.getData();
    },
    rowClick(row) {
      this.acitveItem = row;
    },
    getData() {
      let obj = {
        visitDate: this.visitDate ? dayjs(this.visitDate).format("YYYY-MM") : null,
        checkDate: this.checkDate ? dayjs(this.checkDate).format("YYYY-MM") : null,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };

      if (this.employeeId) {
        obj.employeeId = this.employeeId;
        obj.employeeName = this.common.valueToLabel(
          this.yzDoctorCheckList.selectEmployeeInfo,
          this.employeeId
        );
      }

      request.post("/saasbaihui/getYzDoctorCheckList", obj).then((res) => {
        let obj = res.result;
        obj.listData.forEach((i) => {
          i.checkInfo = JSON.parse(i.checkInfo);
          i.patientInfo = i.patientInfo ? JSON.parse(i.patientInfo) : {};
          i.checkVisitTypeStr = i.checkVisitType == 1 ? "初诊" : "复诊";
          i.patientInfoStr = `${i.patientInfo.patientName} ${i.visitDate} ${i.checkVisitTypeStr}`;
          i.employeeInfo = JSON.parse(i.employeeInfo);
          i.employeeInfoStr = i.employeeInfo.map((i) => i.label).join(",");
          i.replyCloseTimeStr =
            i.replyCloseTime && [10, 20].includes(i.doctorReplyType)
              ? this.updateCountdown(i.replyCloseTime)
              : "";
          i.hospitalName = this.common.valueToLabel(
            this.hospitalList,
            i.hospitalCode
          );
        });
        if (obj.selectEmployeeInfo) {
          obj.selectEmployeeInfo.forEach((i) => {
            i.value = i.employeeId;
            i.label = i.employeeName;
            return i;
          });
        } else {
          obj.selectEmployeeInfo = [];
        }
        this.totalCount = res.total;
        this.yzDoctorCheckList = obj;
      });
    },
    updateCountdown(endTime) {
      endTime = dayjs(endTime);
      const duration = dayjs.duration(endTime.diff(dayjs()));
      if (duration.asMilliseconds() <= 0) {
        return "";
      } else {
        return `${duration.days()}天 ${duration.hours()}小时 ${duration.minutes()}分钟`;
      }
    },
    closeDetail() {
      this.acitveItem = null;
      this.handleClearCurrentRow();
    },
    handleClearCurrentRow() {
      this.$refs.currentRowTable.clearCurrentRow();
    },
    init() {
      this.getData();
    },
    // 设置表格高度
    setTableHeight() {
      try {
        if ($(".textualReview").length)
          this.u_table_heigh = $(".t_body")[0].clientHeight;
      } catch (error) {}
    },
    refresh() {
      if (this.activeItem) {
        this.$Modal.confirm({
          title: "提示",
          content: "你有新的待回复, 是否自动加载?",
          width: "300px",
          onOk: () => {
            this.getData();
          },
        });
      } else {
        this.getData();
      }
    },
  },
  mounted() {
    Promise.all([this.$store.dispatch("getDirectHospitalList")]).then(() => {
      this.init();
    });

    this.setTableHeight();
    // 窗口大小调整
    $(window).resize(() => {
      this.setTableHeight();
    });

    this.$bus.on("TODONumber", this.refresh);
  },
  destroyed() {
    this.$bus.off("TODONumber", this.refresh);
  },
};
</script>

<style lang="scss" scoped>
.textualReview {
  padding: 15px;
  display: flex;
  height: 100%;
  overflow: hidden;
  .left {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .hender {
      margin-bottom: 10px;
      flex-shrink: 0;
      .item {
        margin-right: 15px;
      }
    }
    .t_body {
      height: 100%;
      overflow-y: auto;
      margin-bottom: 15px;
      .ivu-table-wrapper {
        height: 100%;
      }
    }
  }
  .right {
    margin-left: 15px;
    width: 45%;
    flex-shrink: 0;
    border-left: 1px solid #ddd;
    padding-left: 15px;
  }
  .ivu-tag {
    border-radius: 10px;
    margin-left: 10px;
  }
}
</style>